import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class SupportProgramService {

  constructor(private http: HttpClient) { }

  public getSupportProgramData(): Observable<any> {
    return this.http.get(`${BASEURL}/v3/support_program`, {
      responseType: 'json',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  }
}
